import RequestQouteIcon from '@mui/icons-material/RequestQuote'; 
import { IconButton, Tooltip} from '@mui/material';

import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTabs } from '../../../../context/TabContext';
import { GetItemQuantityInvoice } from '../../../../api/invoicing';

InvoiceIcon.propTypes = {
  row: PropTypes.object,
  overrideOrderId: PropTypes.string,
};

export default function InvoiceIcon({ row, overrideOrderId }) {
  const { id: orderId = '' } = useParams();
  const id = overrideOrderId || orderId;
  const { addNewTabAndNavigate } = useTabs();
  const handleIconClick = async () => {
      try {
        const response = await GetItemQuantityInvoice(row.vendorItemId, row.vendorId, id);
        if (response && response.data && response.data > 0)
          addNewTabAndNavigate(`/dashboard/invoicing/pending/${response.data}`); 
      } catch (error) {
          console.error("Error fetching invoice data:", error);
      }
  };

  return (
    <div>
      <Tooltip PopperProps={{ disablePortal: false }} title={row?.approved === false ? "" : row?.statusUpdates?.some(status =>
        status.updatedBy?.toLowerCase()?.includes('invoice') && !status.status?.toLowerCase()?.includes('item substituted')) ? "Invoiced" :
        (row.vendorInfo?.sendsInvoice ? `Awaiting Invoice File` : `No Invoice Expected On PS`)}
        disableHoverListener={row?.deleted === true}>
        <span>
          <IconButton disableRipple edge="end" disabled={row?.deleted === true} onClick={handleIconClick}>
            <RequestQouteIcon
              sx={{ ml: 0.5, fontSize: '1.00rem' }}
              color={row?.statusUpdates?.some(status =>
                status.updatedBy?.toLowerCase()?.includes('invoice') && !status.status?.toLowerCase()?.includes('item substituted')) ? "secondary" : "grey"}
            />
          </IconButton>
        </span>
      </Tooltip>
    </div>
  );
}